import { Typography, Box, LinearProgress, Grid } from "@material-ui/core";
import PoolCardStyle from "../components/Projects/PoolsStyle";
import { USDollar } from "../utils/currency/usd";
const LinearProgressBar = (props:any) => {
  const classes = PoolCardStyle();
  return (
    <div className={classes.progressContainer}>
      <Grid container spacing={1} justifyContent="space-between">
        <Grid item xs={12} spacing={0}>
            <LinearProgress 
              variant={props.value >= 0 ? "determinate" : "indeterminate"} 
              style={{
                height: 6,
              }}
              {...props} 
            />
        </Grid>
        {
          props.showFull && (
            <Box
              className={classes.progressMarkers}
            >
              <Box>
                <Typography
                  style={{
                    fontSize: "11px",
                  }}
                >
                  $0
                </Typography>
              </Box>
              <Box>
                <Typography
                  style={{
                    fontSize: "11px",
                  }}
                >
                  { 
                    (props.totalRaised) ? `${USDollar.format(props.totalRaised)}/` : ''
                  }
                  {
                    (props.maxRaise) ? `${USDollar.format(props.maxRaise)}` : ''
                  }
                </Typography>
              </Box>
            </Box>
          )
        }
      </Grid>
    </div>
  );
};


export default LinearProgressBar;